import React from "react";
// import ReactDOM from 'react-dom';
import { createRoot } from "react-dom/client";
import App from "./App";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import axios from "axios";
import { store, persistor } from "./store";
import AppLoader from "./_common/components/elements/full-page-loader/appLoader";
import { ACTIONS, API_URL, SELECTED_EVENT_STORAGE, STORAGE } from "./_config";
import { setSSOCookie } from "./_common/utils/ssoCookie";
import { SSOHandler } from "./_common/components/SSOHandler";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "react-confirm-alert/src/react-confirm-alert.css";
import "react-datepicker/dist/react-datepicker.css";
import { SocketProvider } from "./_common/hooks/custom/SocketContext";
import { HelmetProvider } from "react-helmet-async";

function render() {
  const container = document.getElementById("root");
  const root = createRoot(container!); // createRoot(container!) if you use TypeScript
  root.render(
    <React.Fragment>
      <HelmetProvider>
        <Provider store={store}>
          <PersistGate loading={null} persistor={persistor}>
            <SocketProvider>
              <React.Fragment>
                <SSOHandler />
                <AppLoader />
                <App />
                <ToastContainer
                  position="top-right"
                  autoClose={5000}
                  hideProgressBar={false}
                  newestOnTop={true}
                  closeOnClick
                  rtl={false}
                  pauseOnFocusLoss
                  draggable
                  pauseOnHover
                />
              </React.Fragment>
            </SocketProvider>
          </PersistGate>
        </Provider>
      </HelmetProvider>
    </React.Fragment>
  );
}

const token = localStorage.getItem(STORAGE);
if (token) {
  try {
    // Loader();
    axios({
      method: "GET",
      url: API_URL.AUTH.DETAILS,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((success) => {
        setSSOCookie(token!);
        store.dispatch({
          type: ACTIONS.AUTH.ME,
          payload: success.data.data.user,
        });
        render();
      })
      .catch((_error) => {
        console.log("Error src/index.tsx file : ", _error);
        // Scrub stale isAuthenticated from redux-persist so SSOHandler isn't blocked by
        // stale auth state after a token validation failure.
        try {
          const raw = localStorage.getItem('persist:root');
          if (raw) {
            const parsed = JSON.parse(raw);
            if (parsed.user) {
              const u = JSON.parse(parsed.user);
              parsed.user = JSON.stringify({ ...u, isAuthenticated: false, user: null, token: null });
              localStorage.setItem('persist:root', JSON.stringify(parsed));
            }
          }
        } catch (_) { /* ignore parse errors */ }
        localStorage.removeItem(STORAGE);
        localStorage.removeItem(SELECTED_EVENT_STORAGE);
        // Do NOT clear the SSO cookie here — it may belong to PFR (still valid).
        // SSOHandler will pick it up and auto-login via SSO after render.
        store.dispatch({
          type: ACTIONS.AUTH.LOGOUT,
        });
        render();
      });
  } catch (e) {
    localStorage.removeItem(STORAGE);
    render();
  }
} else {
  // No local token — render immediately. SSOHandler will pick up any SSO cookie
  // and handle cross-site auto-login inside React (same path as tab-focus scenario).
  render();
}

// Service worker removed - using content-hashed filenames for caching
// The suicide service worker (public/sw.js) handles cleanup of old service workers
// No additional cleanup needed in the app code

